/* eslint-disable import/no-extraneous-dependencies */
import { LinearProgress, useMediaQuery } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import * as Sentry from "@sentry/react";
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import CachingController from './CachingController';
import BottomMenu from './common/components/BottomMenu';
import ConnectionStatus from './common/components/ConnectionStatus';
import theme from './common/theme';
import { hasPlatformAccessLocked, useChecador } from './common/util/permissions';
import { infoDialog, isMobile } from './common/util/utils';
import { useEffectAsync } from './reactHelper';
import OfflineDevicesAlert from './settings/components/OfflineDevicesAlert';
import SocketController from './SocketController';
import { sessionActions } from './store';
import APP_VERSION from './Version';

const useStyles = makeStyles(() => ({
  page: {
    flexGrow: 1,
    overflow: 'auto',
  },
  menu: {
    zIndex: 4,
  },
}));

const App = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const checador = useChecador();
  const isLocked = hasPlatformAccessLocked();

  const desktop = useMediaQuery(theme.breakpoints.up('sm'));

  const newServer = useSelector((state) => state.session.server.newServer);
  const initialized = useSelector((state) => !!state.session.user);

  useEffectAsync(async () => {
    console.log('App effect - initialized:', initialized);
    console.log('App effect - isLocked:', isLocked);
    console.log('App effect - checador:', checador);

    if (!initialized) {
      const response = await fetch('/api/session');
      console.log('Session response ok:', response.ok);
      if (response.ok) {
        const user_session = await response.json();
        dispatch(sessionActions.updateUser(user_session));
        const subusers = await fetch('/api/subusers');
        dispatch(sessionActions.updateSubusers(await subusers.json()));

        // const parentUsers = await fetch('/api/users/parent');
        // dispatch(sessionActions.updateParentUsers(await parentUsers.json()));

        // Sentry.setUser({ ...user_session });
      } else if (newServer) {
        navigate('/register');
      } else {
        navigate('/login');
      }
      return null;
    }

    if (isLocked) {
      navigate('/locked');
    } else if (checador) {
      navigate('/exits');
    }

    return null;
  }, [initialized]);


  return !initialized ? (
    <LinearProgress />
  ) : (
    <>
      <ConnectionStatus />
      <SocketController />
      <CachingController />
      <OfflineDevicesAlert />
      <div className={classes.page}>
        <Outlet />
      </div>
      {!desktop && (
        <div className={classes.menu}>
          <BottomMenu />
        </div>
      )}
    </>
  );
};

export default App;
